import React from 'react';

// "Image" atom — düz semantik <img>. (Eskiden reactstrap <Media> sarıyordu;
// native Media `object` prop'u olmadan <div> üretiyor → logo/avatar `<div src=>`
// olarak bozuk HTML render ediliyordu. Atom adı zaten Image → doğrudan <img>.)
const Image = (props) => <img alt="" {...props.attrImage} />;

export default Image;